import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_user_merchant",
  ref: "addUserMerchantRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-600px w-100" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_add_user_merchant_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "modal-body p-0" }
const _hoisted_10 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_11 = { class: "svg-icon svg-icon-1 position-absolute ms-4" }
const _hoisted_12 = { class: "card-box pt-10" }
const _hoisted_13 = { class: "card-box pt-10" }
const _hoisted_14 = { class: "h-300px d-flex flex-column justify-content-center align-items-center" }
const _hoisted_15 = { class: "modal-footer flex-right" }
const _hoisted_16 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "indicator-label" }
const _hoisted_19 = { class: "svg-icon svg-icon-3" }
const _hoisted_20 = { class: "indicator-progress" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_empty_search = _resolveComponent("empty-search")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.t("user.addMerchant")), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createVNode(_component_el_form, {
          onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen021.svg" })
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.search) = $event)),
                    onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.searchUserMerchantItems && _ctx.searchUserMerchantItems(...args))),
                    class: "form-control form-control-solid ps-15"
                  }, null, 544), [
                    [_vModelText, _ctx.formData.search]
                  ]),
                  _withDirectives(_createElementVNode("span", {
                    class: "svg-icon svg-icon-1 position-absolute top-50 end-0 mr-2 translate-middle",
                    style: {"cursor":"pointer"},
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.removeSearch && _ctx.removeSearch(...args)))
                  }, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                  ], 512), [
                    [_vShow, _ctx.formData.search != '']
                  ])
                ]),
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("h3", null, _toDisplayString(_ctx.t("user.results")) + ":", 1),
                  _createVNode(_component_el_table, {
                    class: "w-100",
                    height: "400",
                    ref: "multipleTableRef",
                    "header-cell-class-name": "align-middle",
                    data: _ctx.formData.items,
                    onSelectionChange: _ctx.handleSelectionChange
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        type: "selection",
                        width: "50"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "name",
                        label: _ctx.t('user.name')
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_table_column, {
                        prop: "vat_registration_number",
                        label: _ctx.t('user.vatRegistrationNumber')
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["data", "onSelectionChange"])
                ])), [
                  [_directive_loading, _ctx.loading],
                  [_vShow, _ctx.formData.items.length !== 0]
                ]),
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_empty_search)
                  ])
                ])), [
                  [_directive_loading, _ctx.loading],
                  [_vShow, _ctx.formData.items.length === 0]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-light me-3",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args)))
              }, [
                _createElementVNode("span", _hoisted_16, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                ]),
                _createElementVNode("span", null, _toDisplayString(_ctx.t("common.cancel")), 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-lg btn-primary",
                disabled: _ctx.isDisabledSubmit || _ctx.loading,
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
              }, [
                _createElementVNode("span", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr075.svg" })
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.t("user.addMerchant")), 1)
                ]),
                _createElementVNode("span", _hoisted_20, [
                  _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                  _hoisted_21
                ])
              ], 8, _hoisted_17)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}